module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-3@2x_29c32c4720a3243fcfb00a63b6d50680.png";